import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async Thunk to fetch categories from the API
export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (_, { getState }) => {
    const { categories, status } = getState().categories;

    // If the status is 'succeeded' and categories are already present, do not call the API
    if (status === 'succeeded' && categories.length > 0) {
      return categories; // Return existing categories
    }
    // Otherwise, make the API call to fetch categories
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await axios.get(`${apiUrl}categories`);
    return response.data;
  }
);

const categorySlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    selectedCategory: null,
    selectedSubCategory: null,
    status: 'idle', // 'idle', 'loading', 'succeeded', 'failed'
    error: null,
  },
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
      state.selectedSubCategory = null; // Reset subcategory when category changes
    },
    setSelectedSubCategory: (state, action) => {
      state.selectedSubCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.categories = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { setSelectedCategory, setSelectedSubCategory } = categorySlice.actions;

export default categorySlice.reducer;
